export class User {
    token: string;
    username: string;
    name: string;
    avatarUrl: string;
    domain: string;

    static create(username: string, token: string) {
        let user = new User();
        user.username = username;
        user.token = token;
        return user;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/models/user.model.ts